<template>
  <div>
    <ValidationObserver ref="JudgesExecutionObserver">
       <template v-if="!execution || (execution && execution.execution_status_id === 1)">
          <b-field grouped>
            <b-field expanded>
              <ValidationProvider name="Juez" :rules="'required'" v-slot="{ errors }">
                <b-field label="Juez" label-position="inside" :type="{ 'is-danger': errors[0] }" :message="errors">
                  <b-autocomplete
                      v-model="judge"
                      placeholder="Selecciona un Juez"
                      :open-on-focus="true"
                      :data="filterJudges"
                      field="name"
                      @select="option => selectedJudge = option" :loading="isLoadingJudges"
                      :custom-formatter="fullName">
                      <template slot-scope="props">
                        {{props.option.lastname}} {{props.option.name}}
                      </template>
                  </b-autocomplete>
                </b-field>
              </ValidationProvider>
            </b-field>
            <b-field expanded>
              <ValidationProvider name="Secretario" :rules="'required'" v-slot="{ errors }">
                <b-field label="Secretario" label-position="inside" :type="{ 'is-danger': errors[0] }" :message="errors">
                  <b-autocomplete
                      v-model="secretary"
                      placeholder="Selecciona un Secretario"
                      :open-on-focus="true"
                      :data="filterSecretaries"
                      field="name"
                      @select="option => selectedSecretary = option" :loading="isLoadingSecretaries"
                      :custom-formatter="fullName">
                      <template slot-scope="props">
                        {{props.option.lastname}} {{props.option.name}}
                      </template>
                  </b-autocomplete>
                </b-field>
              </ValidationProvider>
            </b-field>
            <b-field label="Posición" label-position="inside" expanded>
              <b-input type="is-light" v-model="position"></b-input>
            </b-field>
            <b-field>
              <b-button type="is-light" icon-left="plus" @click="addJudgeExecution">Agregar</b-button>
            </b-field>
          </b-field>
       </template>
      </ValidationObserver>
      <b-table
        :data="filterJudgesExecutions"
        :striped="true"
        :hoverable="true"
        :narrowed="true"
        :paginated="false"
        :loading="isLoading"
        :mobile-cards="false"
        :key="`judges-execution-table-${componentKey}`">

        <template slot-scope="props">
            <b-table-column field="id" label="#" width="40" centered>
                {{ props.index + 1 }}
            </b-table-column>

            <b-table-column field="judgeName" label="Juez">
                {{ props.row.judge_fullname }}
            </b-table-column>

            <b-table-column field="secretaryName" label="Secretario">
                {{ props.row.secretary_fullname }}
            </b-table-column>

            <b-table-column field="position" label="Posición">
              <b-input size="is-small" v-model="selectedRow.position" v-if="enableEdit && selectedIndex === props.index"/>
              <span v-else>{{ props.row.position ? props.row.position : 'No registrada' }}</span>
            </b-table-column>

            <b-table-column field="accions" centered>
              <div class="buttons">
                <template v-if="!enableEdit">  
                  <b-button type="is-danger" size="is-small" @click="remove(props.row, props.index)" v-if="!execution || (execution && execution.execution_status_id === 1)" :loading="isDeleteLoading && indexDeleting === props.index ">
                    <b-icon icon="close" size="is-small"></b-icon>
                  </b-button>
                  <b-button  type="is-success" size="is-small" @click="editJudgesExecution(props.row, props.index)">
                    <b-icon icon="pencil" size="is-small"></b-icon>
                  </b-button>
                </template>
                <b-button v-if="enableEdit && selectedIndex === props.index" type="is-primary" size="is-small" @click="saveJudgesExecution(props.row, props.index)">
                  <b-icon icon="content-save" size="is-small"></b-icon>
                </b-button>
              </div>
            </b-table-column>
        </template>

        <section class="section" slot="empty" style="padding: 1.5rem 1.5rem;">
          <div class="content has-text-grey has-text-centered">
            <template v-if="isLoading">
              <p>
                <b-icon icon="dots-horizontal" size="is-large" />
              </p>
              <p>Cargando Caballos...</p>
            </template>
            <template v-else>
              <p>
                <b-icon icon="horseshoe" size="is-large" />
              </p>
              <p>No hay jueces registrados&hellip;</p>
            </template>
          </div>
        </section>
    </b-table>
  </div>
</template>

<script>
import JudgeService from '@/services/JudgeService'
import SecretaryService from '@/services/SecretaryService'

export default {
  props: {
    judgesExecutionList: {
      type: Array,
      default: () => []
    },
    deletedJudges: {
      type: Array,
      default: () => []
    },
    riderId: {
      default: null
    },
    executionId: {
      required: false,
      default: null
    },
    execution: {
      require: false,
      default: null
    } 
  },
  created () {
    this.getJudges()
    this.getSecretaries()
  },
  data () {
    return {
      judge: '',
      secretary: '',
      position: '',
      judgesExecution: [],
      selectedJudge: null,
      selectedSecretary: null,
      judges: [],
      secretaries: [],
      isLoadingJudges: false,
      isLoadingSecretaries: false,
      componentKey: 0,
      isLoading: false,
      isDeleteLoading: false,
      indexDeleting: null,
      enableEdit: false,
      selectedRow: null,
      selectedIndex: null
    }
  },
  methods: {
    async getJudges () {
      this.isLoadingJudges = true
      let params = {
        'user_status_id': 1
      }
      let response = await JudgeService.getJudges(params)
      this.judges = response.data.data
      this.isLoadingJudges = false
    },
    async getSecretaries () {
      this.isLoadingSecretaries = true
      let params = {
        'user_status_id': 1
      }
      let response = await SecretaryService.getSecretaries(params)
      this.secretaries = response.data.data
      this.isLoadingSecretaries = false
    },
    async addJudgeExecution () {
      if (await this.$refs.JudgesExecutionObserver.validate()) {
        let judgeExecution = {
          'judge_id': this.selectedJudge.id,
          'judge_fullname': this.fullName(this.selectedJudge),
          'secretary_id': this.selectedSecretary ? this.selectedSecretary.id : null,
          'secretary_fullname': this.selectedSecretary ? this.fullName(this.selectedSecretary) : null,
          'position': this.position,
          'order': 1,
          'new': true,
          'deleted': false
        }
        this.judgesExecution.push(judgeExecution)
        this.judge = ''
        this.secretary = ''
        this.position = ''
        this.selectedJudge = null
        this.selectedSecretary = null
        this.$nextTick(() => {
          this.$refs.JudgesExecutionObserver.reset()
        })
      }
    },
    fullName (object) {
      return `${object.lastname} ${object.name}`
    },
    remove (row, index) {
      this.isDeleteLoading = true
      this.indexDeleting = index

      if (row.id) {
        row.deleted = true
      } else {
        this.judgesExecution.splice(index, 1)
      }
      this.$emit('update:deletedJudges', this.deletedJudgesExecutions)

      this.indexDeleting = null
      this.isDeleteLoading = false
      this.forceRerender()
    },
    editJudgesExecution (row, index) {
      this.enableEdit = true;
      this.selectedRow = JSON.parse(JSON.stringify(row));
      this.selectedIndex = index;
    },
    saveJudgesExecution (row, index) {

      this.judgesExecution[index].position = this.selectedRow.position;
      this.judgesExecution[index].edited = row.id ? true : false;

      this.enableEdit = false;
      this.selectedRow = null;
      this.selectedIndex = null;
      this.$emit('update:judgesExecutionList', this.judgesExecution);
    },
    forceRerender () {
      this.componentKey++
    }
  },
  computed: {
    filterJudges () {
      return this.judges.filter((judge) => {
        let fullName = `${judge.lastname} ${judge.name}`.toString().toLowerCase()
        let likeSearch = fullName.indexOf(this.judge.toLowerCase()) >= 0
        let notPreviusSelected = this.judgesExecution.findIndex((x) => x.judge_id === judge.id || x.secretary_id === judge.id) === -1
        let notSecretary = this.selectedSecretary ? judge.id !== this.selectedSecretary.id : true
        let notRider = this.riderId !== judge.id
        return likeSearch && notPreviusSelected && notSecretary && notRider
      })
    },
    filterSecretaries () {
      return this.secretaries.filter((secretary) => {
        let fullName = `${secretary.lastname} ${secretary.name}`.toString().toLowerCase()
        let likeSearch = fullName.indexOf(this.secretary.toLowerCase()) >= 0
        let notPreviusSelected = this.judgesExecution.findIndex((x) => x.judge_id === secretary.id || x.secretary_id === secretary.id) === -1
        let notJudge = this.selectedJudge ? secretary.id !== this.selectedJudge.id : TextTrackCue
        let notRider = this.riderId !== secretary.id
        return likeSearch && notPreviusSelected && notJudge && notRider
      })
    },
    filterJudgesExecutions () {
      return this.judgesExecution.filter((x) => x.deleted === false)
    },
    deletedJudgesExecutions () {
      return this.judgesExecution.filter((x) => x.deleted === true)
    }
  },
  watch: {
    selectedJudge (newValue, oldValue) {
      if (oldValue && !newValue) {
        this.judge = ''
      }
    },
    riderId (value) {
      if (value) {
        if (this.selectedJudge && value === this.selectedJudge.id) {
          this.selectedJudge = null
          this.judge = ''
        }
        if (this.selectedSecretary && value === this.selectedSecretary.id) {
          this.selectedSecretary = null
          this.secretary = ''
        }
      }
    },
    judgesExecutionList (value) {
      if (value) {
        this.judgesExecution = value
      } else {
        this.judgesExecution = []
      }
      this.forceRerender()
    },
    judgesExecution (value) {
      this.$emit('update:judgesExecutionList', value)
      this.$emit('update:deletedJudges', this.deletedJudgesExecutions)
    }
  }
}
</script>
